"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedSearchPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var SearchPageBase_1 = require("./SearchPageBase");
var AdvancedSearchFormPanel_1 = require("./AdvancedSearchFormPanel");
var AdvancedSearchPage = /** @class */ (function (_super) {
    __extends(AdvancedSearchPage, _super);
    function AdvancedSearchPage(props) {
        var _this = _super.call(this, props) || this;
        _this.validate = function (params) {
            var valid = !!((params.startDate || params.endDate) &&
                params.premiumType &&
                params.policyStatus);
            if (!valid) {
                return {
                    valid: false,
                    message: "To search for a customer you must use the following mandatory fields:\n" +
                        "1) policy start or end date\n" +
                        "2) premium type\n" +
                        "3) policy status"
                };
            }
            return { valid: true };
        };
        _this.onSearch = function () {
            var _a = _this.state, searchParameters = _a.searchParameters, limit = _a.limit, offset = _a.offset;
            var queryParams = _this.formatQueryParams(__assign(__assign({}, searchParameters), { limit: limit, offset: offset }));
            _this.supportPortalService.getPartiesAdvanced(queryParams).subscribe(function (searchResult) {
                _super.prototype.setState.call(_this, {
                    loading: false,
                    searchResult: searchResult,
                    noResultError: searchResult.count === 0
                });
            }, function () { return _super.prototype.setState.call(_this, { loading: false }); });
        };
        _this.logAgentActivity = function (reference) {
            _this.supportPortalService.logAgentActivity(reference, {
                action: "No Action",
                customer: "Account"
            }).subscribe();
        };
        _this.state = __assign(__assign({}, _this.state), { searchParameters: {
                productId: undefined,
                startDate: undefined,
                endDate: undefined,
                addons: [],
                totalDrivers: undefined,
                premiumType: "",
                tier: "",
                firstYear: undefined,
                amendments: undefined,
                policyStatus: undefined
            } });
        return _this;
    }
    ;
    AdvancedSearchPage.prototype.render = function () {
        var _this = this;
        var auth = this.authorize();
        if (auth)
            return auth;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AdvancedSearchFormPanel_1.AdvancedSearchFormPanel, { onSearch: this.handleSearch, onSearchParameterChange: function (parameter, value) {
                        var _a;
                        return _this.setState({
                            searchParameters: __assign(__assign({}, _this.state.searchParameters), (_a = {}, _a[parameter] = value, _a))
                        });
                    }, limit: this.state.limit, offset: this.state.offset }), this.renderPagination(), this.renderSpinner(), this.supportPortalTemplates.renderFooter()] }));
    };
    AdvancedSearchPage.prototype.formatQueryParams = function (params) {
        var formatted = {};
        Object.entries(params).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value === undefined || value === null || value === "")
                return;
            if (value instanceof Date) {
                // convert Date to YYYY-MM-DD string
                formatted[key] = "".concat(value.getFullYear(), "-").concat(String(value.getMonth() + 1).padStart(2, '0'), "-").concat(String(value.getDate()).padStart(2, '0'));
            }
            else {
                formatted[key] = value;
            }
        });
        return formatted;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], AdvancedSearchPage.prototype, "supportPortalService", void 0);
    AdvancedSearchPage = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], AdvancedSearchPage);
    return AdvancedSearchPage;
}(SearchPageBase_1.SearchPageBase));
exports.AdvancedSearchPage = AdvancedSearchPage;
//# sourceMappingURL=AdvancedSearchPage.js.map